import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import Modal from "../../../components/modal";
import { AddUpdateEMSOffice } from "../../../../api";
import { Formik } from "formik";
import * as Yup from "yup";
import TextInput from "../../../components/form/text-input";
import FancyRadioInput from "../../../components/form/fancy-radio-input";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import toast from "react-hot-toast";
import useEmsOfficeStore from "../../../stores/ems-office";

const schema = Yup.object().shape({
  office_id: Yup.string()
    .required('* Kurv Office is required'),
  name: Yup.string().nullable().max(100, '* Name must be 100 characters or less'),
  risk_type: Yup.string().nullable()
    .required('* Risk Type is required'),
});


const AddAndEditEMSOffice = ({
  isModalOpen,
  closeModal,
  getEMSOfficesList,
}) => {
  const [is_submitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    office_id: "",
    name: "",
    risk_type: "",
  });

  const setRecordToEdit = useEmsOfficeStore((state) => state.setRecordToEdit);
  const recordToEdit = useEmsOfficeStore((state) => state.recordToEdit);

  const onSubmit = async (values) => {
    const toastId = toast.loading('Loading...');

    let form_data = {
      office_id: values.office_id,
      name: values.name,
      risk_type: values.risk_type,
    }

    if (recordToEdit) {
      form_data.id = recordToEdit.id
    }

    try {
      const response = await AddUpdateEMSOffice(form_data);
      if (response?.status) {
        toast.success(response?.message, { id: toastId });
        getEMSOfficesList();
        reset();
        closeModal();
      } else {
        toast.error(response?.message, { id: toastId });
        getEMSOfficesList();
        reset();
        closeModal();
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: toastId });
    }

  };

  const onClose = () => {
    reset();
    closeModal();
  };

  const reset = () => {
    setIsSubmitted(false);
    setFormData({
      office_id: "",
      name: "",
      risk_type: "",
    });
    setRecordToEdit(null);
  }

  useEffect(() => {
    if (recordToEdit) {
      setFormData({
        office_id: recordToEdit.office_id,
        name: recordToEdit.name ?? "",
        risk_type: recordToEdit.risk_type,
      });
    }
  }, [recordToEdit])

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={onClose}
      header={`${recordToEdit ? "Edit" : "Add"} Kurv Office`}
    >

      <Formik
        enableReinitialize
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={formData}
        validateOnBlur={true}
        validateOnChange={true}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off" className={styles.formContainer} >
            <div className={`${styles.grid} ${styles.gridCols1} ${styles.gap1}`}>
              <TextInput
                label={'Kurv Office'}
                id={'office_id'}
                name={'office_id'}
                placeholder={'Kurv Office'}
                value={values.office_id}
                onChange={handleChange}
                error={errors.office_id}
                errored={errors.office_id}
                touched={touched.office_id}
              />
            </div>

            <div className={`${styles.grid} ${styles.gridCols1} ${styles.gap1}`}>
              <TextInput
                label={'Name'}
                id={'name'}
                name={'name'}
                placeholder={'Name'}
                value={values.name}
                onChange={handleChange}
                error={errors.name}
                errored={errors.name}
                touched={touched.name}
              />
            </div>

            <div className={styles.formGroup}  >
              <p className={styles.heading} >Risk Type</p>

              <div className={styles.riskTypeRadioContainer} >
                <FancyRadioInput
                  id={'low'}
                  name={'risk_type'}
                  label={'Low'}
                  value={'low_risk'}
                  checked={values.risk_type === 'low_risk'}
                  onChange={handleChange}
                />

                <FancyRadioInput
                  id={'high'}
                  name={'risk_type'}
                  label={'High'}
                  value={'high_risk'}
                  checked={values.risk_type === 'high_risk'}
                  onChange={handleChange}
                />
              </div>
              {errors.risk_type && <p className={styles.error}>{errors.risk_type}</p>}
            </div>
          
            <div className={styles.footer} >
              <ButtonIcon
                textColor="#254FE2"
                bgColor={'white'}
                type={'button'}
                onClick={onClose}
              >
                Cancel
              </ButtonIcon>

              <ButtonIcon
                textColor="#FFFFFF"
                bgColor={'#4C70EF'}
                type="submit"
              >
                Save
              </ButtonIcon>
            </div>

          </form>
        )}
      </Formik>

    </Modal>
  );
};

export default AddAndEditEMSOffice;
